<script setup>
import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';

defineProps({
  campaigns: {
    type: Array,
    required: true,
  },
  isLiveChatType: {
    type: Boolean,
    default: false,
  },
  showAnalytics: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['edit', 'delete', 'viewAnalytics']);

const handleEdit = campaign => emit('edit', campaign);
const handleDelete = campaign => emit('delete', campaign);
const handleViewAnalytics = campaign => emit('viewAnalytics', campaign);
</script>

<template>
  <div class="flex flex-col gap-4">
    <div
      v-for="campaign in campaigns"
      :key="campaign.id"
      :data-campaign-id="campaign.id"
      class="rounded-xl transition-shadow duration-300"
    >
      <CampaignCard
        :title="campaign.title"
        :message="campaign.message"
        :is-enabled="campaign.enabled"
        :status="campaign.campaign_status"
        :sender="campaign.sender"
        :inbox="campaign.inbox"
        :scheduled-at="campaign.scheduled_at"
        :is-live-chat-type="isLiveChatType"
        :show-analytics="showAnalytics"
        :stats="campaign.stats.sent_messages"
        @edit="handleEdit(campaign)"
        @delete="handleDelete(campaign)"
        @view-analytics="handleViewAnalytics(campaign)"
      />
    </div>
  </div>
</template>
